export default __webpack_public_path__ + "static/media/gallery21.56b584cd.jpg";